import { Card, Grid } from '@material-ui/core';
import { Captions, LongBody, ShortBody } from 'components/Typography';
import React from 'react';
import styled from 'styled-components';

const StyledCard = styled(
  ({
    backgroundImage,
    backgroundColor,
    paddingRight,
    paddingLeft,
    ...otherProps
  }) => <Card {...otherProps} />,
)`
  && {
    padding: 14px 24px;
    background-image: ${(props) => `url(${props.backgroundImage})`};
    background-color: ${(props) => props.backgroundColor};
    background-size: cover;
    background-repeat: no-repeat;
    background-position: right bottom 55%;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    padding-right: ${(props) => props.paddingRight};
    padding-left: ${(props) => props.paddingLeft};
  }
`;

const StyledIcon = styled.img<{ width: string; height: string }>`
  &&& {
    width: ${({ width }) => width};
    height: ${({ height }) => height};
    margin-right: 10px !important;
  }
`;

const StyledLongBody = styled(LongBody)<{ matches: boolean }>`
  margin: 0 !important;
  font-size: ${({ matches }) => (matches ? '13.23px !important;' : '16px')}
  margin-left: ${({ matches }) => (matches ? '-10px !important;' : '0')}

`;

export const ReversedStyledGrid = styled(Grid)<{ reverse: boolean }>`
  flex-direction: ${({ reverse }) => (reverse ? 'row-reverse' : 'row')};
`;

const StyledCaption = styled(
  ({ textAlign, marginBottom, fontSize, matches, reverse, ...otherProps }) => (
    <Captions {...otherProps} />
  ),
)`
  &&& {
    text-align: ${(props) => props.textAlign};
    margin-bottom: ${(props) => props.marginBottom};
    font-size: ${({ matches, fontSize }) =>
      matches ? '9.1px !important' : `${fontSize}px !important`};
    margin-left: ${(props) => (props.reverse ? '6px' : '0px')};
  }
`;
const StyledGrid = styled(
  ({ textAlign, marginBottom, height, ...otherProps }) => (
    <Grid {...otherProps} />
  ),
)`
  text-align: ${(props) => props.textAlign} !important;
  margin-bottom: ${(props) => props.marginBottom} !important;
  height: ${(props) => props.height || 'auto'} !important;
`;

const StyledCaptionValue = styled(
  ({ textAlign, marginBottom, fontSize, matches, reverse, ...otherProps }) => (
    <Captions {...otherProps} />
  ),
)`
  &&& {
    text-align: ${(props) => props.textAlign};
    margin-bottom: ${(props) => props.marginBottom};
    font-size: ${({ matches, fontSize }) =>
      matches ? '10.75px !important' : `${fontSize}px !important`};
    margin-left: ${(props) => (props.reverse ? '6px' : '0px')};
  }
`;

export const StyledResGrid = styled(Grid)<{ matches: boolean }>`
  font-size: ${({ matches }) =>
    matches ? '9.1px !important' : '11px !important'};
`;
const StyledShortBody = styled(({ matches, lineHeight, ...props }) => (
  <ShortBody {...props} />
))`
  &&& {
    margin-bottom: 0px;
    line-height: ${({ lineHeight }) => lineHeight};
    font-size: ${({ matches }) => (matches ? '11px !important;' : '')};
  }
`;
export {
  StyledShortBody,
  StyledCard,
  StyledIcon,
  StyledLongBody,
  StyledCaption,
  StyledGrid,
  StyledCaptionValue,
};
